import React from "react";
import { Footer } from "@nef/core";
import styled from "styled-components";

const StyledAppFooter = styled(Footer)`
  &.app-footer {
    font-family: sans-serif;
    width: 100%;
    position: static;
  }
  p {
    text-align: center;
    margin: auto;
  }
`;

export default StyledAppFooter;
